module.exports = __webpack_public_path__ + "img/2ndline.b19365fd.png";